// Dark header: the account pill is transparent (the gradient avatar circle inside is the brand
// element) instead of the contained brand-blue fill used on the light header.
const getPillBackground = palette =>
  palette.mode === 'dark' ? 'transparent' : palette.primary.main;

const getPillActiveBackground = palette =>
  palette.mode === 'dark' ? 'transparent' : palette.primary.dark;

export const buttonStyles = {
  padding: '10px 14px',
  textTransform: 'none',
  color: ({ palette }) => `${palette.common.white} !important`,
  height: 'unset',
  flexShrink: 0,
  backgroundColor: ({ palette }) => `${getPillBackground(palette)} !important`,

  '&:hover': {
    backgroundColor: ({ palette }) => `${getPillActiveBackground(palette)} !important`,
  },

  '&[data-is-active="true"]': {
    backgroundColor: ({ palette }) => `${getPillActiveBackground(palette)} !important`,
  },
};

export const flatMenuStyles = {
  a: {
    font: ({ typography }) => typography.medium16,
    color: ({ palette }) => `${palette.text.link}`,
    textDecoration: 'none',
  },
};
